import { TESTIMONIALS, BUSINESS } from "@/data/site";
import { Reveal } from "@/components/site/Reveal";
import { Star, Quote, ExternalLink } from "lucide-react";

const Stars = () => (
  <div className="flex gap-1" aria-label="5 out of 5 stars">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className="w-4 h-4 fill-brand text-brand" />
    ))}
  </div>
);

export const Testimonials = () => (
  <section id="reviews" className="py-24 lg:py-36 bg-paper border-y border-line">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
        <div className="lg:col-span-8">
          <h2 className="font-heading uppercase leading-[0.9] tracking-tight text-4xl sm:text-6xl lg:text-7xl text-ink">
            Rated 5.0 by<br />the people we<br />work for.
          </h2>
        </div>
        <div className="lg:col-span-4 lg:text-right">
          <div className="font-heading text-7xl text-brand leading-none">{BUSINESS.ratingValue}</div>
          <Stars />
          <p className="text-ink-soft text-sm mt-3 font-mono tracking-wide lg:ml-auto">
            Based on {BUSINESS.reviewCount}+ reviews
          </p>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-px bg-line border border-line">
        {TESTIMONIALS.map((t, i) => (
          <Reveal
            key={t.name}
            delay={(i % 2) * 0.08}
            className="bg-white p-8 lg:p-12 flex flex-col gap-6"
          >
            <div data-testid={`testimonial-${t.name.toLowerCase()}`} className="flex items-center justify-between">
              <Stars />
              <Quote className="w-8 h-8 text-line" />
            </div>
            <p className="text-lg lg:text-xl text-ink leading-relaxed">"{t.quote}"</p>
            <div className="mt-auto flex items-center gap-3 pt-4 border-t border-line">
              <span className="grid place-items-center w-10 h-10 rounded-full bg-brand text-void font-heading text-lg">
                {t.name[0]}
              </span>
              <span className="font-heading uppercase tracking-tight text-ink">{t.name}</span>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="mt-12 flex justify-center">
        <a
          href={BUSINESS.socials.yell}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="reviews-yell-cta"
          className="group inline-flex items-center gap-3 border border-line px-7 py-4 text-ink font-medium hover:border-brand hover:text-brand transition-colors duration-200"
        >
          Read all reviews on Yell
          <ExternalLink className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </div>
    </div>
  </section>
);
